<template>
  <div style="    background: rgb(249, 250, 254);">
    <nav_list></nav_list>

    <div class="per">

      <div class="t1">
        <div class="tit1">

          {{ $lang(42340) }}

        </div>
        <div class="img1">
          <img src="~@/../static/image/cover1.png" alt="">
        </div>
        <div class="train">
          <span class="tit2">{{ $lang(42341) }} </span>
          <div class="con1">
            <span>{{ info.trainv.strs.sn }} </span>
          </div>
        </div>
        <div class="txt1">
          <div class="text1">
            <span v-html="info.trainv.strs.info"> </span>
          </div>
        </div>
        <div class="txt1">
          <div class="text1">
            <span>{{ $lang(42376) }} </span><br>
            <span> {{ $lang(42375) }}</span>
          </div>
        </div>
      </div>

      <div class="t2">
        <div class="step1">
          <div class="con1">
            <img src="~@/../static/image/ok.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42342) }}</span><br>
              <span class="u2">{{ $lang(42343) }}</span>
            </div>
          </div>
          <div class="con1">
            <img src="~@/../static/image/step2.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42344) }}</span><br>
              <span class="u2">{{ $lang(42345) }}</span>
            </div>
          </div>
          <div class="con1">
            <img src="~@/../static/image/step3.png" alt="">
            <div class="y1">
              <span class="u1">{{ $lang(42346) }}</span><br>
              <span class="u2">{{ $lang(42347) }}</span>
            </div>
          </div>
        </div>

        <div class="channel">
          <div class="screen">
            <div :class="'block1 ' + tag.cls" v-for="(tag, j) in info.trainv.strs.tags" :key="j">
              <div class="y2">

                <span> {{ tag.tit }}</span>
              </div>
            </div>



          </div>
          <div class="lef">
            <table class="lis_tab">
              <tr class="tit3">
                <td class="bl bl_ft" v-for="(pt, n) in info.trainv.strs.start_points" :key="n">
                  {{ pt.title }}
                </td>
                <td class="yel bl_ft" v-for="(pt, n) in info.trainv.strs.end_points" :key="n">
                  {{ pt.title }}
                </td>
              </tr>
              <tr>
                <td class="bl" v-for="(pt, n) in info.trainv.strs.start_points" :key="n">
                  {{ pt.time }}
                </td>
                <td class="yel" v-for="(pt, n) in info.trainv.strs.end_points" :key="n">
                  {{ pt.time }}
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="sele1">
          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42348) }}</span>
            </div>
            <div class="ipt1">

              {{ info.date }}

            </div>
          </div>
          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42349) }}</span>
            </div>
            <div class="ipt1">
              <el-select class="ipt" v-model="put.start_point_id">
                <el-option v-for="(pt, n) in info.trainv.strs.start_points" :key="n" :label="pt.title + ' ' + pt.time"
                  :value="n">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="y3">
            <div class="tit4">
              <span>{{ $lang(42350) }}</span>
            </div>
            <div class="ipt1">
              <el-select class="ipt" v-model="put.end_point_id">
                <el-option v-for="(pt, n) in info.trainv.strs.end_points" :key="n" :label="pt.title + ' ' + pt.time"
                  :value="n">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>



        <div class="notes">
          <div class="text3">
            <span> {{ $lang(42354) }}</span>
          </div>

        </div>

        <div class="people_info">
          <!-- 乘客基本信息 -->
          <div class="tit5">
            <span>{{ $lang(42355) }} </span>
          </div>


          <div class="r1" v-for="(itm, i) in put.contacts " :key="i" >

            <div class="info2">
              <div class="block3">
                <div class="sub_tit2">
                  <span>{{ $lang(42357) }}</span>
                </div>
                <div class="ipt3">
                  <el-input v-model="put.contacts[i].name" :placeholder="$lang(42362)"></el-input>
                </div>
              </div>

              <div class="block3">
                <div class="sub_tit2">
                  <span> {{ $lang(42356) }} </span>
                </div>
                <div class="ipt3">
                  <el-radio-group v-model="put.contacts[i].sex">

                    <el-radio class="ipt4" :label="1"> {{ $lang(42358) }}</el-radio>
                    <el-radio class="ipt4" :label="0"> {{ $lang(42359) }}</el-radio>
                  </el-radio-group>

                </div>
              </div>
              <div class="block3">
                <div class="sub_tit2">
                  <span>{{ $lang(42360) }} / {{ $lang(42361) }} </span>
                </div>
                <div class="ipt3">
                  <el-input-number type="number" @change="age_change" max="120" min="1" v-model="put.contacts[i].age"
                    :placeholder="$lang(42363)">
                  </el-input-number>
                  <span class="ss"></span>
                </div>

              </div>
              <div class="block3">
                <div class="sub_tit2">
                  <span>{{ $lang(42493) }} </span>
                </div>
                <div class="ipt3">
                  <div class="iptpricex">
                    {{itm.price}} {{ $lang(42374) }}
                    <el-button type="danger" icon="el-icon-delete" circle @click="del_contacts(i)"></el-button>
                  </div>

                </div>

              </div>

              <!-- <div class="btnn">
                <div class="" v-if="put.contacts.length > 1">

                </div>

              </div> -->
            </div>

          </div>
          <div class="contacts_boot">
            <el-button type="success" icon="el-icon-plus" circle @click="add_contacts"></el-button>
          </div>
          <!--  -->

          <!--  -->
        </div>

        <!-- 联系 -->
        <div class="contact">
          <div class="sele1">
            <div class="y3">
              <div class="tit4">
                <span> {{ $lang(42364) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.tel" :placeholder="$lang(42365)"></el-input>
              </div>
            </div>
            <div class="y3">
              <div class="tit4">
                <span> {{ $lang(42366) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.mail" :placeholder="$lang(42367)"></el-input>
              </div>
            </div>
            <div class="y3">
              <div class="tit4">
                <span> {{ $lang(42368) }}</span>
              </div>
              <div class="ipt1">
                <el-input class="ipt" v-model="put.wx_num" :placeholder="$lang(42369)"></el-input>
              </div>
            </div>
          </div>
        </div>

        <div class="notes">
          <div class="text3">
            <span> {{ $lang(42370) }} </span>
          </div>
        </div>

        <div class="total_amount">
          <div class="text4">
            <span> {{ $lang(42371) }} ：</span>
          </div>
          <div class="total">
            <span> {{ decimal(info.price.strs.rmb_price * info.children_price * man_num + children_num) }}
              {{ $lang(42374) }} </span>
          </div>
        </div>

        <div class="up_down">
          <div class="btn" @click="back()">
            <span> {{ $lang(42372) }} </span>
          </div>
          <div class="btn" @click="smbt()">
            <span>{{ $lang(42373) }} </span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import nav_list from './nav_list.vue';
export default {
  name: "personal_info",
  components: {  //注册
    nav_list,
  },
  data() {
    let r = []

    for (let i = 0; i < 50; i++) {
      r.push({
        name: '',
        sex: 0,
        age: 30,
        price: 30,
      })
    }
    console.log(r)
    return {
      msg: "",
      radio: '1',
      name: '',
      age: '',
      radio2: '1',
      name2: '',
      age2: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        },]
      },
      value2: '',
      man_num: 0,
      children_num: 0,
      tel: '',
      email: '',
      wxnum: '',
      id: 0,
      info: {},
      contacts: r,
      put: {
        start_point_id: 0,
        end_point_id: 0,
        contacts: [
          {
            name: '',
            sex: 0,
            age: 30,
            price: 0,
          }
        ],
        train_realtime_id: 0,
        train_price_id: 0,
        tel: '1514609527',
        mail: 'geslan@Live.cn',
        wx_num: 'ddddd',
      },


    };
  },
  mounted() {
    this.id = this.cache('rtm_id')
    if (!this.id) {
      this.jump('/')
    }
    this.put.train_realtime_id = this.cache('rtm_id')
    this.put.train_price_id = this.cache('price_id')
    this.f5()
  },
  methods: {
    add_contacts() {
      this.put.contacts.push({
        name: '',
        sex: 0,
        age: 30,
        price: 0,
      })
      this.$forceUpdate()
    },
    del_contacts(i) {
      this.put.contacts.splice(i, 1)
    },
    smbt() {
      let n = this.man_num + this.children_num
      let contacts = []
      for (let i = 0; i < n; i++) {
        let row = this.contacts[i]
        if (!row.name || !row.age) {

          return this.$message(this.$lang('42355') + (i + 1) + '' + this.$lang(42411));
        }
        contacts.push(row)
      }
      this.put.contacts = contacts
      this.get("/train/create_order", this.put, 'post').then((e) => {

        this.jump('/confirm_info?sn=' + e.sn)
      });
    },
    age_change(value) {
      this.man_num =  0
      this.children_num =  0
      for (let i in this.put.contacts) {
        if (this.put.contacts[i].age > 12) {
          this.man_num++
        } else {
          this.children_num++
        }
      }
    },
    f5() {
      this.get("/train/info", { id: this.id }).then((e) => {
        this.info = e.info
        for (let i in this.info.trainv.strs.start_points) {
          this.put.start_point_id = i
          break
        }
        for (let i in this.info.trainv.strs.end_points) {
          this.put.end_point_id = i
          break
        }


      });
    },
  }
}
</script>

<style scoped>
.contacts_boot {
  display: flex;
  justify-content: end;
  padding-right: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
<style scoped>
.bl {
  width: 149px;
  height: 52px;
  box-sizing: border-box;
  background: rgb(242, 246, 250);
  border: 1px solid rgb(203, 217, 234);
  border-radius: 4px 0px 0px 0px;
}

.yel {
  width: 149px;
  height: 52px;
  box-sizing: border-box;
  background: rgb(255, 251, 229);
  border: 1px solid rgb(255, 218, 71);
}

.per {
  display: flex;
  margin-top: 2%;

}

/* 详细信息 */
.t1 {
  margin-left: 14%;
  width: 330px;
  height: 85vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(108, 117, 125, 0.1);
  border-radius: 10px;
}

.t1 .tit1 {
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: rgb(4, 100, 221);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  text-align: center;
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 400;
}

.t1 .tit1 .info {
  display: flex;
  margin: 0 auto;
  width: 72px;
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 0%;
}

.t1 .tit1 .info span {
  margin-top: 19%;
}

.t1 .img1 img {
  width: 330px;
  height: 191px;
}

.t1 .img1 img {
  width: 330px;
  height: 191px;
}

.t1 .train {
  display: flex;
  width: 100%;
  margin-bottom: 3%;
}

.t1 .train .tit2 {
  margin-right: 4%;
  margin-left: 6%;
  margin-top: 2%;
  color: rgb(4, 100, 221);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 500;
  line-height: 27px;
  letter-spacing: 0%;
  text-align: center;
}

.t1 .train .con1 {
  margin-right: 2%;
  margin-top: 2%;
  color: rgb(33, 37, 41);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0%;
}

.t1 .txt1 {

  width: 100%;
  background: rgb(249, 250, 254);
  border-radius: 5px;
  width: 90%;
  padding: 5px;
  margin: auto;
  margin-bottom: 10%;
}

.t1 .txt1 .text1 {
  margin-left: 6%;
  margin-right: 6%;
  margin-top: 3%;
  margin-bottom: 3%;
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0%;
  text-align: left;
}

.t2 {
  display: flex;
  flex-direction: column;
  margin-left: 2%;
}

.t2 .step1 {
  width: 58vw;
  height: 14vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(108, 117, 125, 0.1);
  border-radius: 10px;
  display: flex;
}

.t2 .step1 .con1 {
  flex: 0 0 33%;
  display: flex;
}

.t2 .step1 .con1 img {
  margin-left: 15%;
  margin-right: 5%;
  margin-top: 12%;
  width: 30px;
  height: 30px;
}

.t2 .step1 .con1 .y1 {
  margin-top: 12%;
}

.t2 .step1 .con1 .y1 .u1 {
  color: rgb(29, 33, 41);
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
  font-weight: bold;
}

.t2 .step1 .con1 .y1 .u2 {
  color: rgb(134, 144, 156);
  font-family: Noto Sans SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0%;
  text-align: left;
}

.t2 .channel {
  margin-top: 1%;
  display: flex;
  flex-direction: column;
  width: 58vw;
  height: 25vh;
  box-sizing: border-box;

  background: rgb(255, 255, 255);
  border: 1px solid rgba(108, 117, 125, 0.1);
  border-radius: 10px;
}

.t2 .screen {
  margin-top: 2%;
  display: flex;
}

.t2 .channel .screen .block1 {
  background-color: rgb(4, 100, 221);
  margin-left: 2%;
  width: 5vw;
  height: 35px;
  line-height: 35px;

  display: flex;
  border-radius: 4px;
}

.t2 .channel .screen .block1 .y2 {
  margin: 0 auto;
}

.t2 .channel .screen .block1 img {
  width: 18px;
  height: 18px;

}

.t2 .channel .screen .block1 span {
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0%;
}

.t2 .channel .lef {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 3%;
  margin-left: 2%;
}

.t2 .channel .lef .lis_tab {
  text-align: center;
  border-spacing: 0px;
}

.t2 .channel .lef .lis_tab .tit3 {
  color: rgb(4, 100, 221);
}

.t2 .sele1 {
  margin-top: 1%;
  width: 58vw;
  height: 15vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(108, 117, 125, 0.1);
  border-radius: 10px;
  display: flex;
}

.t2 .sele1 .y3 {
  flex: 0 0 30%;
  margin-top: 3%;
  margin-left: 3%;
}

.t2 .sele1 .y3 .tit4 span {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  text-align: center;

}

.t2 .sele1 .y3 .ipt1 {
  margin-top: 2%;
}

.t2 .sele1 .y3 .ipt1 .ipt {
  width: 15vw;
}

.t2 .people_sele {
  margin-top: 1%;
  width: 58vw;
  height: 14vh;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(108, 117, 125, 0.1);
  border-radius: 10px;
  display: flex;
}

.t2 .people_sele .y4 {
  margin-left: 3%;
  margin-top: 3%;
  flex: 0 0 40%;
}

.t2 .people_sele .y4 .tit4 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
}

.t2 .people_sele .y4 .ipt2 {
  margin-top: 2%;
}

.t2 .people_sele .y4 .ipt2 .sub_tit {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-right: 5%;
}

.t2 .people_sele .y4 .ipt2 .xh {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0%;
  margin-right: 5%;
  margin-left: 5%;
}

.t2 .notes {

  width: 58vw;

  box-sizing: border-box;


}

.t2 .notes .text3 {
  margin-top: 1%;
  line-height: 80px;
  min-height: 80px;
  background: rgb(245, 249, 253);
  border: 1px solid rgb(94, 144, 204);
  border-radius: 10px;
  align-items: center;

}

.t2 .notes .text3 span {
  color: rgb(51, 102, 162);
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 400;

  letter-spacing: 0%;
  display: block;
  margin-left: 25px;
}

.t2 .people_info {
  width: 58vw;
  margin-top: 1%;
  box-sizing: border-box;
  background: rgb(255, 255, 255);
  border: 1px solid rgba(108, 117, 125, 0.1);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.t2 .people_info .r1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2%;
}

.t2 .people_info .tit5 {
  margin-top: 2%;
  margin-left: 18px;
  color: rgb(33, 37, 41);
  font-family: Noto Sans SC;
  font-size: 20px;
  font-weight: 500;
  line-height: 40px;
  letter-spacing: 0%;
  border-bottom: 1px solid #eee;
}

.t2 .people_info .r1 .info2 {
  width: 100%;
  display: flex;
}

.t2 .people_info .r1 .info2 .block3 {
  flex: 0 0 25%;
  align-items: center;

}
.t2 .people_info .r1   .btnn {
  flex: 0 0 5%;

    height: 73px;
    line-height: 100px;
  align-items:center;
}

.t2 .people_info .r1 .info2 .block3 .sub_tit2 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-top: 2%;
  margin-left: 7%;

}

.t2 .people_info .r1 .block3 .ipt3 {
  color: rgb(66, 84, 134);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 40px;
  height: 40px;
  letter-spacing: 0%;
  margin-top: 2%;
  margin-left: 7%;

}

.t2 .people_info .r1 .block3 .ipt3 .ss {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-left: 3%;
  margin-top: 2%;

}
.t2 .people_info .r1 .block3 .ipt3 .iptpricex {
  color: rgb(108, 117, 125);
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  letter-spacing: 0%;
  margin-left: 3%;


}

.t2 .people_info .r1 .block3 .ipt3 .ipt4 {
  width: 20%;
  margin-top: 4%;
}


.t2 .total_amount {
  width: 58vw;
  height: 8.5vh;
  margin-top: 1%;
  box-sizing: border-box;
  background: rgb(255, 247, 237);
  border: 1px solid rgb(247, 175, 72);
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.t2 .total_amount .text4 {
  color: rgb(208, 126, 9);
  font-family: Noto Sans SC;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0%;
}

.t2 .total_amount .total {
  color: rgb(255, 121, 0);
  font-family: Noto Sans SC;
  font-size: 28px;
  font-weight: 700;
  line-height: 41px;
  letter-spacing: 0%;
  margin-right: 5%;
}

.t2 .up_down {
  width: 58vw;
  display: flex;
}

.t2 .up_down .btn {
  margin: 0 auto;
  margin-top: 3%;
  margin-bottom: 4%;
  width: 180px;
  height: 48px;
  background: rgb(255, 121, 0);
  border-radius: 2px;
  display: flex;
}

.t2 .up_down .btn span {
  margin: 0 auto;
  color: rgb(255, 255, 255);
  font-family: Noto Sans SC;
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  letter-spacing: 0%;
  margin-top: 5%;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/personal_info2.vue